import TogglePane from '../global/TogglePane';

/**
 * Modernized GUI Elements Handler for lbbw-am.de
 * Converted to Plain JS for Rollup
 */
document.addEventListener('DOMContentLoaded', () => {
  const urlParams = new URLSearchParams(window.location.search);
  const hash = window.location.hash;

  /**
   * 1. Initiale Tab-Aktivierung beim Laden
   */
  const initTabs = () => {
    let activeTabId = null;

    // Priorität 1: Hash in der URL (#zusammensetzung)
    const fondsTabIdentifiers = ['infos', 'zusammensetzung', 'wertentwicklung', 'fondsmanager', 'nachhaltigkeit'];
    const urlTabHash = hash.replace('#', '');

    if (document.getElementById('fondsdetails') && fondsTabIdentifiers.includes(urlTabHash)) {
      activeTabId = urlTabHash;
    }
    // Priorität 2: URL Query Parameter (?tab=...)
    else if (urlParams.has('tab')) {
      activeTabId = urlParams.get('tab');
    }
    // Priorität 3: Kontextabhängige Defaults
    else if (document.getElementById('fondsdetails')) {
      activeTabId = 'infos';
    } else if (document.getElementById('sitesearch')) {
      activeTabId = 'fonds';
    }

    if (activeTabId) {
      console.log('Auto-activating tab:', activeTabId);
      // Kurze Verzögerung um sicherzugehen, dass alle anderen Scripte (Charts etc.) bereit sind
      const timer = setTimeout(() => {
        document.removeEventListener('click', cancelOnUserToggle, true);
        TogglePane.toggle(activeTabId, true);
      }, 1000);

      // Eine Auswahl des Nutzers hat Vorrang vor der automatischen Aktivierung.
      function cancelOnUserToggle(event) {
        if (event.target.closest('[data-toggle]')) {
          clearTimeout(timer);
          document.removeEventListener('click', cancelOnUserToggle, true);
        }
      }
      document.addEventListener('click', cancelOnUserToggle, true);
    }
  };

  /**
   * 2. Accordion Spezial-Logik (eigenständige Komponente)
   */
  const handleAccordionClick = (event) => {
    const trigger = event.target.closest('[data-toggle-accordion]');
    if (!trigger) return;

    event.preventDefault();
    const targetId = trigger.getAttribute('data-toggle-accordion');
    const currentPane = trigger.closest('.accordion-panes-pane');
    const container = currentPane ? currentPane.parentNode : null;

    // Alle anderen im selben Container schließen
    if (container) {
      Array.from(container.children).forEach(sibling => {
        if (sibling !== currentPane) {
          const target = sibling.querySelector('[data-toggle-target]');
          const btn = sibling.querySelector('[data-toggle-accordion]');
          if (target) {
            target.classList.remove('toggle__active');
            target.hidden = true;
          }
          if (btn) btn.classList.remove('gui--toggle__active');
        }
      });
    }

    // Aktuelles Element toggle
    const activePanel = document.querySelector(`[data-toggle-target="${targetId}"]`);
    if (activePanel) {
      const isNowActive = !activePanel.classList.contains('toggle__active');

      trigger.classList.toggle('gui--toggle__active', isNowActive);
      activePanel.classList.toggle('toggle__active', isNowActive);
      activePanel.hidden = !isNowActive;

      // Scroll-Korrektur
      if (isNowActive && currentPane) {
        const index = Array.from(container.children).indexOf(currentPane);
        if (index > 2) {
          setTimeout(() => {
            const scrollPos = activePanel.offsetTop - (trigger.offsetHeight * 2);
            window.scrollTo({ top: scrollPos, behavior: 'smooth' });
          }, 250);
        }
      }
    }
  };

  /**
   * 3. "Toggle This" Handler (einfache Auf/Zu Logik)
   */
  const handleToggleThisClick = (event) => {
    const trigger = event.target.closest('[data-toggle-this]');
    if (!trigger) return;

    trigger.classList.toggle('gui--toggle__active');
    const target = trigger.nextElementSibling;
    if (target && target.hasAttribute('data-toggle-target')) {
      target.classList.toggle('toggle__active');
    }
  };

  // Event Listener registrieren
  document.addEventListener('click', (e) => {
    handleAccordionClick(e);
    handleToggleThisClick(e);
  });

  // Init ausführen
  initTabs();
});